import { PageViews } from "./pageViews";


export class PageViewsTracking {
    // staff
    structures;

    constructor() {
        this.init();
    }

    init() {
        this.structures = $('.page-view');
        if (!this.structures.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.structures.on('click', '.slider__button--prev, .slider__button--next', (e) => this.onPagination(e));
    }

    onPagination(e) {
        const pageViews = new PageViews();
        const button = $(e.target);
        const activeIndex = pageViews.swipers[0].activeIndex;

        this.sendGTMEvent({
            posicion: this.getPaginationDirection(button),
            index: activeIndex,
            event: 'pagination'
        });
    }

    sendGTMEvent(data) {
        if (window.dataLayer) {
            console.debug('Pagination event track ', data);
            window.dataLayer.push(data);
        }
    }

    // auxiliary
    getPaginationDirection(button) {
        return button.is('.slider__button--prev') ? 'izq' : 'drc';
    }
}
